import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function fitVertically(position, context) {
  var isWithinWindow = context.isWithinWindow,
      targetHeight = context.targetHeight,
      targetMarginTop = context.targetMarginTop,
      targetMarginBottom = context.targetMarginBottom,
      withinHeight = context.withinHeight,
      withinScrollTop = context.withinScrollTop,
      withinTop = context.withinTop;
  var withinOffset = isWithinWindow ? withinScrollTop : withinTop;
  var collisionHeight = targetHeight + targetMarginBottom + targetMarginTop;
  var collisionPositionTop = position.top - targetMarginTop;
  var overTop = withinOffset - collisionPositionTop;
  var overBottom = collisionPositionTop + collisionHeight - withinHeight - withinOffset;
  var newPositionTop = position.top;
  var newOverBottom; // The target element is taller than the within element.

  if (targetHeight > withinHeight) {
    // The target element is initially over the top of the within element.
    if (overTop > 0 && overBottom <= 0) {
      newOverBottom = position.top + overTop + collisionHeight - withinHeight - withinOffset;
      newPositionTop += overTop - newOverBottom; // The target element is initially over bottom of the within element.
    } else if (overBottom > 0 && overTop <= 0) {
      newPositionTop = withinOffset; // The target element is initially over both top and bottom of the within element.
    } else if (overTop > overBottom) {
      newPositionTop = withinOffset + withinHeight - collisionHeight;
    } else {
      newPositionTop = withinOffset;
    } // The target element is too far up from the within element.

  } else if (overTop > 0) {
    newPositionTop += overTop; // The target element is too far down from the within element.
  } else if (overBottom > 0) {
    newPositionTop -= overBottom; // Adjust based on position and margin
  } else {
    newPositionTop = Math.max(position.top - collisionPositionTop, position.top);
  }

  return _objectSpread(_objectSpread({}, position), {}, {
    top: newPositionTop
  });
}